export async function getCep(cep: string) {
  const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`, {
    mode: 'cors',
  }).then(res => {
    return res.json();
  });

  return response;
}
